import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Box, Typography } from "@mui/material";
import { useLazyCheckControlQuery } from "../../../../middleware/controllersApi";
import { PATHS } from "../../../../constants";
import { useAction } from "../../../../hooks/actions";

const Header = ({ uuid, isConnected, setIsConnected, setIsSnackbarOpen, handleCancel, isSubmitDisabled }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { setIsErrorRequest } = useAction();
  const [checkControl, { error: errorCheckControl }] = useLazyCheckControlQuery();

  const testConnection = () => {
    checkControl({ uuid }).then((response) => setIsConnected(response.data));
    setIsSnackbarOpen(true);
  };

  useEffect(() => {
    setIsErrorRequest(errorCheckControl);
  }, [errorCheckControl]);

  return (
    <Box className="template_page-header">
      <Typography className="title-page">{t("title_page:add_controller")}</Typography>
      <Box className="template_page-header-buttons">
        {uuid && (
          <Button className="btn btn-primary-fill" onClick={testConnection}>
            {isConnected ? t("button:check_connection") : t("button:try_once_more")}
          </Button>
        )}
        <Button className="btn btn-white" onClick={handleCancel}>
          {t("button:comeback")}
        </Button>
        <Button form="add-controller" className="btn btn-primary-fill" type="submit" disabled={isSubmitDisabled}>
          {t("button:save")}
        </Button>
      </Box>
    </Box>
  );
};

export default Header;
